import React, { Component } from "react";
import { connect } from "react-redux";

import { getLoggedInUser } from "../helpers/authUtils";
import CrudBar from "../gb-components/CrudBar";
import IconDelete from '../assets/svg/ic-actions-trash.svg';
import PreLoaderWidget from "../components/Loader";
import { getAssistentes, getProfissionais, saveAssistente } from "../Libs/assistente.js";
import { Col, Row } from "reactstrap";
import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import Confirm from "../gb-components/ConfirmModal/index.js";


class Assistentes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: getLoggedInUser(),
      assistentes: null,
      profissionais: null,
      profSelected: "",
      loading: true,
      assistenteRef: null,
      showConfirmDelete: false,
    };
    this.adicionarAssistente = this.adicionarAssistente.bind(this);
    this.deletarAssistente = this.deletarAssistente.bind(this);
  }

  async getAssistentesPage() {
    this.setState({ loading: true })
    const assistentesAux = await getAssistentes(this.state.user.cpf)
    this.setState({
      assistentes: assistentesAux,
      loading: false
    })

  }

  async componentDidMount() {
    console.log(this.state.user)
    this.setState({ loading: true })

    const profissionaisAux = await getProfissionais()
    const profissionais = profissionaisAux.map(a => { return { label: a.nome, value: a } })

    this.setState({ profissionais })
    await this.getAssistentesPage()
  }

  async adicionarAssistente() {
    if (this.state.profSelected == "") {
      return toast.error("Selecione um profissional")
    }
    let hasAssistent = this.state.assistentes.filter(a => a.cpf === this.state.profSelected.value.CPF)
    if (hasAssistent.length > 0) {
      return toast.error("Assistente já foi adicionado")
    }

    const val = this.state.profSelected.value
    const data = {
      nome: val.nome,
      email: val.email,
      cpf: val.CPF,
      profissao: val.profissao,
      telefone: val.telefone,
      userRef: val.ref
    }
    await saveAssistente(data, this.state.user.cpf)
    await this.getAssistentesPage()
  }

  async deletarAssistente() {
    await this.state.assistenteRef.delete()
    await this.getAssistentesPage()
    this.setState({ showConfirmDelete: false })
  }

  render() {
    return (
      <React.Fragment>
        <div className="gb-cont-page">
          <CrudBar
            title="Assistentes"
            breadcrumb={["Globalbrain", "Assistentes"]}
          />

          <Confirm
            open={this.state.showConfirmDelete}
            confirmButtonAction={() => { this.deletarAssistente(); }}
            cancelButtonAction={() => { this.setState({ showConfirmDelete: false }) }}
          >
          </Confirm>

          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover />

          <div className="gb-page">
            {this.state.loading ? (<div className="text-center"><PreLoaderWidget /></div>) :
              <React.Fragment>
                <Row>
                  <Col md={6}>
                    <Select
                      value={this.state.profSelected}
                      onChange={(v) => {
                        this.setState({ profSelected: v })
                      }}
                      placeholder="Pesquise um profissional..."
                      options={this.state.profissionais}
                      noOptionsMessage={() => "Nenhum resultado encontrado"}
                      className="gb-default-input2"
                    />
                  </Col>
                  <Col md={6}>
                    <button className="btn gb-button pl-4 pr-4"
                      onClick={() => {
                        this.adicionarAssistente();
                      }}>
                      <i className='fa fa-plus mr-1'></i>Adicionar assistente</button>
                  </Col>

                </Row>
                <Row>
                  {this.state.assistentes && this.state.assistentes.length === 0 &&
                    <Col md={12}>
                      <p className="p-4 text-center" style={{ fontSize: 16 }}>Nenhum assistente adicionado ainda</p>
                    </Col>
                  }
                </Row>


                {this.state.assistentes
                  && this.state.assistentes.length > 0 ?
                  <div className="table-responsive">
                    <table className="table gb-table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Profissão</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.assistentes.map(
                          (item, index) => {
                            return (
                              <tr key={index}>
                                <td scope="row" className="text-center">{index + 1}</td>
                                <td className="text-center">{item.nome}</td>
                                <td className="text-center">{item.profissao}</td>
                                <td className="text-center">
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({
                                        showConfirmDelete: true,
                                        assistenteRef: item.ref
                                      })
                                    }}
                                    className="linkDelete mr-1"
                                  >
                                    <img src={IconDelete} />
                                  </a>
                                </td>
                              </tr>
                            )
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                  : null}

              </React.Fragment>
            }
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect()(Assistentes);
